import React, { useEffect, useState } from "react";
import CustomTable from "../../../../widgets/table";
import { floraServices } from "../../../../service/fileServices/environmentFlora";
import { PendingColumns } from "../partials/columns";
import { useTranslation } from "react-i18next";
import Pagination from "../../../../widgets/pagination";
import { userService } from "../../../../service/plateServices";
import { DEFAULT_PAGE_SIZE } from "../../../../constants/constants";
import { scheduleService } from "../../../../service/scheduleService";

interface PendingTableLabtestProps {
  setDebouncedScanCode: (id: string) => void;
  setTab?: string;
}
const PendingTableLabtest: React.FC<PendingTableLabtestProps> = ({
  setDebouncedScanCode,
  setTab,
}) => {
  const { t } = useTranslation();
  const [pendingDataTable, setPendingDataTable] = useState<Array<any>>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [batchCode, setBatchCode] = useState("");
  const [keyWord, setkeyWord] = useState("");
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [plateBatches, setPlateBatches] = useState([]);
  const [plateSerielNum, setPlateSerielNums] = useState([]);
  const [labStatus, setLabStatus] = useState("");
  const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [scheduleProductId, setScheduleProductId] = useState("");
  const [productId, setProductId] = useState("");
  const [sort, setSort] = useState("activity_start_date_time");
  const [order, setOrder] = useState("desc");
  const sortRemoveList=["lab_status","sl_no"]
  

  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");

    if (storedData) {
      var storedObject = JSON.parse(storedData);
    }
    getPendingPlates();
    listPlateBatch();
    listSerialNumber();
    getProductionSchedules();
    getProductList();
    setUseEffectRequired(false);
  }, [useEffectRequired]);

  //get pending plate list for labtest
  const getPendingPlates = async () => {
    try {
      const response = await floraServices.PendingLabtestPlates(
        page,
        pageSize,
        batchCode,
        keyWord,
        labStatus,
        sort,
        order, 
        scheduleProductId, 
        productId
      );
      if (response?.status && response?.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPages(response?.totalPages);
            setTotalElements(response?.totalElements);
            let rowData: any = response.data.map(
              (element: any, index: number) => {

               const plateType = parseInt(element.plate_type, 10);
               let plateTypeStatus = userService.plateType(plateType);
               
                return {
                  sl_no: index + 1,
                  production_schedule: element.production_schedule_name,
                  product_name: element.product_name,
                  id: element.id,
                  serial_number: element.serial_number,
                  batch_code: element.batch_number,
                  plate_type: element.assigned_activity_name,
                  lab_status: element.lab_status,
                };
              }
            );
            setPendingDataTable(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setPendingDataTable([]);
        setTotalPages(0);
        setTotalElements(0);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

   // function to sort table
  const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  //batch list for filter dropdown
  const listPlateBatch = async () => {
    try {
      const response = await userService.listPlateBatch();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  value: element.batch_number,
                  label: element.batch_number,
                };
              }
            );
            setPlateBatches(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("Plate response", error);
    }
  };

  //handle pagination icon click
  const onNavigateFloraClick = (data: any) => {
    setDebouncedScanCode(data);
  };

  // get ProductionScheduleList
  const getProductionSchedules = async () => {
    try {
      const response = await scheduleService.getProductionSchedules();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //serial number listing for table drop down
  const listSerialNumber = async () => {
    try {
      const response = await userService.listSerialNumber();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  value: element.serial_number,
                  label: element.serial_number,
                };
              }
            );
            setPlateSerielNums(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error("Plate response", error);
    }
  };

  //handle table filters
  const handleFilter = (key: string, value: string) => {
    if (key === "search") {
      setkeyWord(value);
    } else if (key === "batch_code") {
      setBatchCode(value);
    } else if (key === "lab_status") {
      setLabStatus(value);
    }else if (key === "productionSchedule") {
      setScheduleProductId(value)
    }else if (key === "productName") {
      setProductId(value)
    }
    setUseEffectRequired(true);
  };

  //handle pagination filter
  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPage(newPage);
    if (pageSize) {
      setPageSize(pageSize);
    }
    setUseEffectRequired(true);
  };

  return (
    <div>
      <div className="me-3" style={{ marginTop: "10px" }}>
        <div className=" mx-3 pe-2" style={{ height: "45vh" }}>
          <CustomTable
            tableHead={t("EnvironmentalFlora.pending")}
            data={pendingDataTable}
            columns={PendingColumns}
            totalElements={totalElements}
            isActionVisible={false}
            isViewVisible={false}
            isSeachable={true}
            showBatchFilter={true}
            showSerielNoFilter={false}
            onUseEffectRequired={() => setUseEffectRequired(true)}
            isNavigateFlora={true}
            onNavigateFloraClick={onNavigateFloraClick}
            plateBatch={plateBatches}
            plateSerialNumber={plateSerielNum}
            onFilterClick={handleFilter}
            showPlateTypeFilter={false}
            prodScheduleList={prodScheduleList}
            productList={productList}
            onSortClick={handleSort}
            removeSortList={sortRemoveList}
          />
        </div>
        <div>
          <Pagination
            page={page}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingTableLabtest;
